import { createUseStyles } from 'react-jss';

const calcLineHeight = (base, size) => `${base * ([4, 5, 6, 7, 8][['xs', 'sm', 'md', 'lg', 'xl'].indexOf(size)])}px`;


const useStyle = createUseStyles((theme) => ({
  generalInput: (props) => ({
    maxWidth: '100%',
    height: 'auto',
    overflow: 'hidden',
    '& .required': {
      color: theme.colors.danger.normal,
      padding: '0 3px',
    },
    '& .label': {
      fontWeight: 'bold',
      display: 'block',
      fontSize: 'inherit',
      height: 18,
      lineHeight: 1.2,
      pointerEvents: 'none',
      userSelect: 'none',
      marginBottom: 2,
      backgroundColor: 'inherit',
    },
    '& .inner': {
      transitionDuration: '150ms',
      transitionTimingFunction: 'ease-in',
      transitionProperty: 'border-color',
      willChange: 'border-color',
      position: 'relative',
      height: 'auto !important',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      overflow: 'hidden',
      '& .inner-tag': {
        display: 'block',
        height: '100%',
        width: '100%',
        flexGrow: 1,
        fontSize: 'inherit',
        '&.textarea': {
          position: 'static',
          resize: 'none',
          paddingTop: '12px',
          minHeight: '68px !important',
        },
        '&:not(.custom)': {
          paddingLeft: 8,
          paddingRight: 8,
        },
        '&:not(.textarea)': {
          lineHeight: calcLineHeight(theme.sizes.base, props._size),
        },
        '&.mask': {
          height: '100%',
          width: '100%',
        },
      },
      '& .input-container': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexGrow: 1,
        alignSelf: 'stretch',
      },
      '& .children': {
        top: 0,
        display: 'inline-block',
        width: 'auto',
        pointerEvents: 'all',
        userSelect: 'none',
        height: '100%',
        padding: '0 8px',
      },
      '& .placeholder': {
        color: theme.colors.background.placeholder,
        position: 'absolute',
        height: '100%',
        width: '100%',
        pointerEvents: 'none',
        userSelect: 'none',
        transformOrigin: theme.direction.static(props._dir) === 'left' ? 'left top' : 'right top',
        transitionDuration: '150ms',
        transitionTimingFunction: 'ease-in-out',
        transitionProperty: 'transform',
        willChange: 'transform',
        paddingLeft: 8,
        paddingRight: 8,
        lineHeight: calcLineHeight(theme.sizes.base, props._size),
      },
      '& .controls': {
        userSelect: 'none',
        top: 0,
        padding: '0 8px',
        height: '100%',
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& > *': {
          backgroundColor: theme.colors.gray.normal,
          fill: theme.colors.gray.text,
          borderRadius: '50%',
          display: 'inline-block',
        },
        '& .dot-icon': {
          backgroundColor: theme.colors.background.dark,
          width: 8,
          height: 8,
        },
        '& .clear-icon': {
          cursor: 'pointer',
        },
      },
    },
    '&.focus:not(.error-true)': {
      '&.default-border .inner': {
        borderColor: theme.colors.background.text,
      },
    },
    '&:not(.empty)': {
      '&.floating-placeholder': {
        '& .placeholder': {
          backgroundColor: theme.colors.background.normal,
          transform: 'scale(0.65) translateY(-0.45em)',
          top: 0,
          maxHeight: '34px',
        },
        '& .inner-tag': {
          paddingTop: '0.4em',
          marginBottom: '-0.4em',
          '&.textarea': {
            paddingTop: '1em',
            marginBottom: '0',
          },
        },
      },
      '&:not(.floating-placeholder) .placeholder': {
        display: 'none',
      },
    },
    // related to InputMask
    '&.has-placeholder.type-mask.empty:not(.floating-placehlder) .inner-tag .part.static': {
      display: 'none',
    },
    '&.focus:not(.empty)': {
      '& .controls .clear-icon': {
        display: 'inline-block',
      },
      '& .controls .dot-icon': {
        display: 'none',
      },
    },
    '&:not(.focus), &.empty': {
      '& .controls .clear-icon': {
        display: 'none',
      },
    },
    '&.error-true': {
      '& .label': {
        color: theme.colors.danger.normal,
      },
      '&.default-border .inner': {
        borderColor: `${theme.colors.danger.normal} !important`,
      },
      '& .inner .controls .dot-icon': {
        backgroundColor: theme.colors.danger.normal,
      },
      '&:not(.empty) .inner .placeholder': {
        color: theme.colors.danger.normal,
      },
    },
    '&.error-false': {
      '& .inner .controls .dot-icon': {
        background: theme.colors.success.normal,
      },
    },
    '&.floating-placeholder': {
      '&.default-border .inner': {
        border: `solid 1px ${theme.colors.background.border}`,
        borderRadius: theme.sizes.radius,
      },
    },
    '&:not(.floating-placeholder)': {
      '&.default-border .inner': {
        borderBottom: `solid 1px ${theme.colors.background.dark}`,
      },
    },
  }),
}));

export default useStyle;
